export default "/kiban/_next/static/images/no-9f396b496aae5ea2348fb296f5eba41c.png";